import { Badge } from '@/components/ui/badge';
import { CheckCircle2, AlertCircle, XCircle } from 'lucide-react';

interface ConnectionStatusBadgeProps {
  isConnected: boolean;
  isPartiallyConfigured?: boolean;
}

export function ConnectionStatusBadge({
  isConnected,
  isPartiallyConfigured = false,
}: ConnectionStatusBadgeProps) {
  if (isConnected) {
    return (
      <Badge className="bg-[#FF7A59] hover:bg-[#FF7A59]/90 text-white border-transparent">
        <CheckCircle2 className="h-3 w-3 mr-1" />
        Connected
      </Badge>
    );
  }

  if (isPartiallyConfigured) {
    return (
      <Badge className="bg-yellow-600 hover:bg-yellow-700">
        <AlertCircle className="h-3 w-3 mr-1" />
        Partial Setup
      </Badge>
    );
  }

  return (
    <Badge variant="destructive">
      <XCircle className="h-3 w-3 mr-1" />
      Not Connected
    </Badge>
  );
}
